export default {
  border: true,
  rounded: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  cursor: 'pointer',
  fareBodyItem: {
    borderRight: true,
    alignItems: 'center',
    height: '100',
    paddingWidth: '2',
    paddingBottom: '0',
    marginBottom: '4',
  },
  showBackgroundImage: false,
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
  },
  showDate: true,
  fareItemDate: {
    textTransform: 'uppercase',
    fontSize: '5',
    paddingBottom: '1',
    monthFormat: 'fullMonths',
    yearStyles: {
      fontWeight: 'light',
    },
  },
  fareItemTripDuration: {
    paddingBottom: '1',
  },
  showOriginDestination: false,
  showHorizontalSeparator: true,
  fareItemHorizontalSeparator: {
    borderTop: true,
    borderWidth: '1',
    paddingBottom: '2',
    width: '25',
    borderColor: 'secondary',
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    textAlign: 'center',
    style: { lineHeight: '1' },
    pricePromoStyles: {
      fontWeight: 'light',
      textTransform: 'uppercase',
      fontSize: '10px',
    },
    currencyStyles: {
      fontSize: '5',
      marginHeight: '2px',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  showDepartureReturnBeforePrice: true,
  fareItemDepartureReturn: {
    display: 'flex',
    paddingBottom: '2',
  },
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureText: 'cmp-label--departure-date-colon',
    fontWeight: 'light',
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnText: 'cmp-label--return-date-colon',
    fontWeight: 'light',
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareItemJourneyTypeTravelClass: {
    display: 'flex',
  },
  fareItemNoPriceAvailable: {
    showIcon: false,
    alignItems: 'center',
    marginTop: 'auto',
    messageStyles: {
      paddingTop: '34px',
      paddingBottom: '40px',
      fontWeight: 'light',
      width: '75',
    },
    showLinkAvailability: true,
    linkAvailabilityStyles: {
      padding: '0',
      marginBottom: '10px',
      marginTop: '-10px',
      fontWeight: 'bold',
      fontSize: '3',
      textColor: 'black',
      textTransform: 'uppercase',
      style: { textDecoration: 'underline' },
    },
  },
};
